import * as React from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import Registry from '../../../global/Registry';

export default class ModalsComponent extends React.Component<{}, void> {

	public constructor () {
		super();
	}

	removeErrorMessage = () => Registry.getInstance().removeErrorMessage();
	removeConfirmation = () => Registry.getInstance().removeConfirmation();

	render() {
		if (Registry.getInstance().errorMessage !== null) {
			return (
				<Modal
					onClose={this.removeErrorMessage}
					open={true}
					size='small'
				>
					<Header icon='warning sign' content='Unfortunately, something went wrong'/>
					<Modal.Content>
						<h3>{Registry.getInstance().errorMessage}</h3>
					</Modal.Content>
					<Modal.Actions>
						<Button color='green' onClick={this.removeErrorMessage} inverted>
							<Icon name='checkmark'/> OK
						</Button>
					</Modal.Actions>
				</Modal>
			);
		}

		if (Registry.getInstance().confirmationMessage !== null) {
			return (
				<Modal
					basic
					onClose={this.removeConfirmation}
					open={true}
					size='small'
				>
					<Header icon='warning sign' content='Are you sure?'/>
					<Modal.Content>
						<h3>{Registry.getInstance().confirmationMessage}</h3>
					</Modal.Content>
					<Modal.Actions>
						<Button inverted onClick={this.removeConfirmation}>No</Button>
						<Button inverted color='red' onClick={() => Registry.getInstance().confirm()}>Yes</Button>
					</Modal.Actions>
				</Modal>
			);
		}

		return null;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/shared/ModalsComponent.tsx